import { AutoSearchMode } from './vehicleAutoSearch';

export const enum AutoNegoState {
    OFF = 0,
    ON = 1,
    WAITING_RESULTS = 2,
    RESULT_TO_REVIEW = 3,
    COMPLETED = 4,
    ERRORED = 5
}

export interface VehicleAutoNegoSession {
    id: number;
    vehicle_id: number;
    messageBodies: {sender: 'MANAGER' | 'AI' | 'TOOL', body: string, at: number}[];
    // Session control
    autoNegoState: AutoNegoState;
    autoRespond: boolean;
    searchMode: AutoSearchMode;
    shouldReturnRegCountry?: boolean;
    selectedCountries?: string[]; // only relevant when AutoSearchMode.SELECTED_COUNTRIES
    fullTruckLoad?: boolean; // whether to filter by minLengthMForFullTruckLoad
    lastTimeCheckedAt?: Date;
    startedAt?: Date;
    endedAt?: Date;
    maxConcurrentNegos?: number;
    targetSuccessfulNegos?: number;
    // Negotiation tracking
    currentActiveNegos?: number; // Global count of active negotiations for the vehicle
    successfulNegosCount?: number; // Count of successful negotiations in this session
    failedNegosCount?: number; // Count of failed negotiations in this session
    // Misc
    notificationSent: boolean;
    statusMessage?: string;
    offers?: string; // JSON array of offer IDs
    executions?: Date[]; // Timestamps of when auto-negotiation executions happened
    createdAt: Date;
    toCloseAt: Date;
}

/**
 * Request payload for starting auto negotiation
 */
export interface StartAutoNegoRequest {
    max_concurrent_negos?: number;
    target_successful_negos?: number;
    search_mode?: AutoSearchMode;
    should_return_reg_country?: boolean;
}

/**
 * Request payload for ending auto negotiation
 */
export interface EndAutoNegoRequest {
    cancel_negotiations: boolean;
    send_email: boolean;
    cancel_reason?: number;
}
